/* ============================================================
   COVRPACK — Gabarit collection « Gobelet carton » v1.0
   Fichier : assets/covrpack-collection.js
   Chargé uniquement sur le template collection.gobelet-carton.

   1. Sélecteur guidé : les puces construisent une URL de filtres
      Shopify (Search & Discovery) et renvoient vers la grille.
   2. Cartes produit : changement de lot → mise à jour du prix au
      gobelet / prix du lot ; boutons quantité.
   3. « Charger plus » : récupère la page suivante via ?section_id=
      et ajoute les cartes à la grille (la pagination reste indexable).

   Tout est délégué au document : le contenu de la grille est remplacé
   en AJAX par theme.js lors d'un filtrage.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Sélecteur guidé ---------- */
  function splitVals(str) {
    return (str || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function buildFinderUrl(finder) {
    var params = new URLSearchParams();
    var pTaille = finder.dataset.paramTaille;
    var pMat = finder.dataset.paramMateriau;
    var pParoi = finder.dataset.paramParoi;
    var pPromo = finder.dataset.paramPromo;
    var promoVal = finder.dataset.promoValue;

    var tailleSets = []; // un set par groupe → intersection entre groupes, union dans un groupe
    var mats = [], parois = [], promo = false;

    finder.querySelectorAll('.cvrc-chips').forEach(function (group) {
      var pressed = group.querySelectorAll('.cvrc-chip[aria-pressed="true"]');
      if (!pressed.length) return;
      var groupTailles = [];
      pressed.forEach(function (chip) {
        groupTailles = groupTailles.concat(splitVals(chip.dataset.taille));
        splitVals(chip.dataset.materiau).forEach(function (v) { mats.push(v); });
        splitVals(chip.dataset.paroi).forEach(function (v) { parois.push(v); });
        if (chip.dataset.promo === 'true') promo = true;
      });
      if (groupTailles.length) tailleSets.push(groupTailles);
    });

    var tailles = null;
    tailleSets.forEach(function (set) {
      if (tailles === null) { tailles = set.slice(); return; }
      tailles = tailles.filter(function (v) { return set.indexOf(v) > -1; });
    });
    // Intersection vide (ex. usage "café" + contenance "36–65 cl") : on garde la contenance choisie explicitement
    if (tailles !== null && !tailles.length && tailleSets.length) tailles = tailleSets[tailleSets.length - 1].slice();

    if (tailles && pTaille) tailles.forEach(function (v) { params.append(pTaille, v); });
    if (mats.length && pMat) uniq(mats).forEach(function (v) { params.append(pMat, v); });
    if (parois.length && pParoi) uniq(parois).forEach(function (v) { params.append(pParoi, v); });
    if (promo && pPromo && promoVal) params.append(pPromo, promoVal);

    var qs = params.toString();
    return finder.dataset.target + (qs ? '?' + qs : '') + '#cvrc-grille';
  }

  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }

  function addField(box, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    box.appendChild(input);
  }

  /* Reconstruit les champs du formulaire à partir des puces actives.
     Le bouton « Afficher » est un submit : le navigateur envoie les filtres
     même si un autre script intercepte le clic. */
  function syncFinderFields(finder) {
    var box = finder.querySelector('[data-cvrc-finder-fields]');
    if (!box) return false;
    box.innerHTML = '';

    var url = buildFinderUrl(finder);
    var query = (url.split('?')[1] || '').split('#')[0];
    if (query) {
      new URLSearchParams(query).forEach(function (value, key) {
        addField(box, key, value);
      });
    }

    // Conserve l'aperçu de thème (éditeur Shopify) lors de la navigation
    var current = new URLSearchParams(window.location.search);
    ['preview_theme_id', 'oseid'].forEach(function (key) {
      if (current.get(key)) addField(box, key, current.get(key));
    });

    return query.length > 0;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cvrc-finder] .cvrc-chip');
    if (chip) {
      var on = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', on ? 'false' : 'true');
      syncFinderFields(chip.closest('[data-cvrc-finder]'));
      return;
    }

    /* ---------- 2b. Quantité ---------- */
    var qtyBtn = e.target.closest('[data-cvrc-qty]');
    if (qtyBtn) {
      var input = qtyBtn.parentNode.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.cvrcQty, 10);
      input.value = Math.max(1, next);
      return;
    }

    /* ---------- 3. Charger plus ---------- */
    var more = e.target.closest('[data-cvrc-more]');
    if (more) {
      e.preventDefault();
      loadMore(more);
    }
  });

  /* ---------- 2. Changement de lot ---------- */
  document.addEventListener('submit', function (e) {
    var finder = e.target.closest && e.target.closest('[data-cvrc-finder]');
    if (!finder) return;
    var hasFilters = syncFinderFields(finder);
    if (!hasFilters) {
      e.preventDefault();
      var grid = document.getElementById('cvrc-grille');
      if (grid) grid.scrollIntoView();
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-cvrc-lot-select]');
    if (!select) return;
    var card = select.closest('.cvrc-card');
    var opt = select.options[select.selectedIndex];
    if (!card || !opt) return;

    setText(card, '[data-cvrc-unit]', opt.dataset.unit);
    setText(card, '[data-cvrc-lot]', opt.dataset.lot);
    setText(card, '[data-cvrc-units]', opt.dataset.units);
    setText(card, '[data-cvrc-compare]', opt.dataset.compare || '');
  });

  function setText(scope, sel, txt) {
    var el = scope.querySelector(sel);
    if (el && txt !== undefined) el.textContent = txt;
  }

  /* ---------- 3. Charger plus ---------- */
  function loadMore(btn) {
    var wrap = btn.closest('[data-cvrc-loadmore]');
    var sectionId = wrap && wrap.dataset.sectionId;
    var grid = document.querySelector('[data-cvrc-grid]');
    if (!wrap || !sectionId || !grid || btn.hasAttribute('disabled')) return;

    var url = new URL(btn.getAttribute('href'), window.location.origin);
    url.searchParams.set('section_id', sectionId);
    var label = btn.textContent;
    btn.setAttribute('disabled', '');
    btn.textContent = (window.covrStrings && window.covrStrings.loading) || 'Chargement…';

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-cvrc-grid]');
        var newWrap = doc.querySelector('[data-cvrc-loadmore]');
        if (!newGrid) throw new Error('grid missing');

        newGrid.querySelectorAll('.cvrc-card').forEach(function (card) { grid.appendChild(card); });

        var shown = grid.querySelectorAll('.cvrc-card').length;
        var total = parseInt((document.querySelector('[data-cvrc-total]') || {}).textContent, 10) || shown;
        document.querySelectorAll('[data-cvrc-shown]').forEach(function (el) { el.textContent = shown; });
        var bar = wrap.querySelector('.cvrc-loadmore__bar');
        if (bar) {
          bar.setAttribute('aria-valuenow', shown);
          var fill = bar.querySelector('i');
          if (fill) fill.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
        }

        var newMore = newWrap && newWrap.querySelector('[data-cvrc-more]');
        var newPagination = newWrap && newWrap.querySelector('.pagination');
        var oldPagination = wrap.querySelector('.pagination');
        if (newPagination && oldPagination) oldPagination.replaceWith(newPagination);

        if (newMore) {
          btn.setAttribute('href', newMore.getAttribute('href'));
          btn.removeAttribute('disabled');
          btn.textContent = label;
        } else {
          btn.remove();
        }

        if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
          window.theme.reinitProductGridItem();
        }
      })
      .catch(function () {
        // Repli : navigation classique vers la page suivante
        btn.removeAttribute('disabled');
        btn.textContent = label;
        window.location.href = btn.getAttribute('href');
      });
  }
})();
